/**
 * Opens a payment URL in a centered popup window — same UX as Google Sign-In.
 *
 * @param {string} url   - The payment/redirect URL to open
 * @param {string} title - Window name (prevents duplicate tabs)
 * @returns {Window|null} - Reference to the popup window
 */
export function openPaymentPopup(url, title = "hazraPayment") {
  const width  = 560;
  const height = 680;

  // Centre relative to the current browser window
  const left = Math.round(window.screenX + (window.outerWidth  - width)  / 2);
  const top  = Math.round(window.screenY + (window.outerHeight - height) / 2);

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    "toolbar=no",
    "menubar=no",
    "scrollbars=yes",
    "resizable=yes",
    "status=no",
    "location=yes",   // show the URL bar so users trust the origin
  ].join(",");

  const popup = window.open(url, title, features);

  // Focus the popup (some browsers open it behind)
  if (popup) popup.focus();

  return popup;
}
